export default "__VITE_ASSET__BXjnoltb__"